import $ from "jquery";
import Storage from "@bd-utils/storage";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";
import jsQR from "jsqr";
import GameLogic from "@bd-core/game-logic";
import CONFIG from "@bd-core/config";

export class MissionPage extends BD_Component {
    constructor() {
        super();

        this.id = "mission";
        this.template = "mission-template";

        this.elms = {
            missionOverview: "#mission-overview",
            missionToggle: ".js-mission-toggle",
            missionDetail: "#mission-detail-popup",
            missionDetailLocation: "#mission-detail-location",
            missionCard: ".js-mission-card",
            openKeyMission: ".js-open-key-mission",
            openLocationMission: ".js-open-location-mission",
            detailClose: ".js-mission-detail-close",
            selectColleague: "#select-colleague-popup",
            addBtn: ".js-add-btn",
            removeBtn: ".js-remove-btn",
            selectColleagueClose: "#select-colleague-close",
            colleagueCard: ".js-colleague-card",
            slotImage: ".js-slot-image",
            cardSlot: ".js-card-slot",
            slotContent: ".js-slot-content",
            missionContent: ".js-mission-content",
            selectColleagueConfirmBtn: "#select-colleague-confirm",
            missionSubmitBtn: "#mission-submit-btn",
            missionColleagueParent: "#mission-colleague-slots",
            scanLocationPopup: "#scan-location-popup",
            scanLocationWarning: "#scan-location-warning",
            scanLocationClose: ".js-scan-location-back",
            scannerElementId: "qr-scanner-reader",
            snackBar: ".js-snackbar",
            snackBarClose: ".js-snackbar-close",
            checkAnimationPopup: ".js-check-animation-popup",
            checkContinueBtn: ".js-check-animation-popup .js-continue",
            achievementAnimationPopup: ".js-achievement-animation-popup",
            achievementContinueBtn: ".js-achievement-animation-popup .js-continue",
            achievementImg: ".js-achievement-animation-popup .js-achievement-img",
            achievementTitle: ".js-achievement-animation-popup .js-achievement-title",
            achievementSubtitle: ".js-achievement-animation-popup .js-achievement-subtitle",
            achievementPoints: ".js-achievement-animation-popup .js-achievement-points",
            pointAnimationPopup: ".js-point-animation-popup",
            pointPoints: ".js-point-animation-popup .js-points",
            pointSeeProgressBtn: ".js-point-animation-popup .js-see-progress",
            pointCloseBtn: ".js-point-animation-popup .js-close",
            scanButton: ".js-open-scan-location-popup",
            closeScanWarningBtn: ".js-scan-location-warning-close",
            searchInput: ".js-search-input",
            filterToggle: ".js-filter-toggle",
            filterClose: ".js-filter-close",
            filterDropdownWrapper: "#select-colleague-filter-wrapper",
            departmentFilters: "#select-colleague-department-filters",
            rarityFilters: "#rarity-filters",
            applyFiltersBtn: ".js-filter-apply",
            resetFiltersBtn: ".js-filter-reset",
            pagination: ".select-colleague__pagination",
            paginationBtn: "[data-pagination-action]",
            paginationFirst: '[data-pagination-action="first"]',
            paginationPrev: '[data-pagination-action="prev"]',
            paginationNext: '[data-pagination-action="next"]',
            paginationLast: '[data-pagination-action="last"]',
            paginationDisabledClass:
                "select-colleague__pagination-btn--disabled",
            // Mission Info Popup
            missionInfoPopup: "#mission-info-popup",
            missionInfoBtn: ".js-mission-info-btn",
            missionInfoClose: ".js-mission-info-close",
            missionInfoTitle: "#mission-info-title",
            missionInfoIntro: "#mission-info-intro",
            missionInfoWysiwyg: "#mission-info-wysiwyg",
            missionInfoLink: "#mission-info-link",
            // Disclaimer Popup
            disclaimerPopup: "#disclaimer-popup",
            disclaimerClose: ".js-disclaimer-close",
        };

        this._events = this.getEvents();

        this.selectedSlotId = null;
        this.selectedDepartmentId = 0;

        this.video = null;
        this.canvas = null;
        this.canvasContext = null;
        this.videoStream = null;
        this.animationFrameId = null;
        this.isScanning = false;

        this.filterDepartmentIds = [];
        this.filterRarityIds = [];
        this.searchQuery = "";
        this.searchDebounceTimer = null;
        this.SEARCH_DEBOUNCE_DELAY = 300; // milliseconds
        this.currentPage = 1;
        this.perPage = 10;
        this.pagination = null;
        this.pendingIncorrectCount = 0;
        this.lastMissionResult = null;
        this.achievementIndex = 0;
    }

    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.missionToggle,
                handler: this.onMissionToggle,
            },
            {
                event: "click",
                selector: elms.openKeyMission,
                handler: this.onOpenKeyMission,
            },
            {
                event: "click",
                selector: elms.openLocationMission,
                handler: this.onOpenLocationMission,
            },
            {
                event: "click",
                selector: elms.detailClose,
                handler: this.onCloseMissionDetail,
            },
            {
                event: "click",
                selector: elms.addBtn,
                handler: this.onOpenSelectColleaguePopup,
            },
            {
                event: "click",
                selector: elms.selectColleagueClose,
                handler: this.onCloseSelectColleaguePopup,
            },
            {
                event: "click",
                selector: elms.colleagueCard,
                handler: this.onSelectColleagueCard,
            },
            {
                event: "click",
                selector: elms.selectColleagueConfirmBtn,
                handler: this.onConfirmSelectColleague,
            },
            {
                event: "click",
                selector: elms.missionSubmitBtn,
                handler: this.onSubmitMission,
            },
            {
                event: "click",
                selector: elms.slotContent,
                handler: this.onCardSlotClick,
            },
            {
                event: "click",
                selector: elms.removeBtn,
                handler: this.onRemoveSelectedAnswer,
            },
            {
                event: "click",
                selector: elms.scanLocationClose,
                handler: this.onCloseScanLocation,
            },
            {
                event: "click",
                selector: elms.snackBarClose,
                handler: this.onCloseSnackBar,
            },
            {
                event: "click",
                selector: elms.scanButton,
                handler: this.onOpenScanLocationPopup,
            },
            {
                event: "click",
                selector: elms.closeScanWarningBtn,
                handler: this.onCloseScanLocationWarning,
            },
            {
                event: "click",
                selector: elms.checkContinueBtn,
                handler: this.onCheckContinue,
            },
            {
                event: "click",
                selector: elms.achievementContinueBtn,
                handler: this.onAchievementContinue,
            },
            {
                event: "click",
                selector: elms.pointSeeProgressBtn,
                handler: this.onSeeProgress,
            },
            {
                event: "click",
                selector: elms.pointCloseBtn,
                handler: this.onPointClose,
            },
            {
                event: "input",
                selector: elms.searchInput,
                handler: this.onSearchInput,
            },
            {
                event: "click",
                selector: elms.filterToggle,
                handler: this.onFilterToggle,
            },
            {
                event: "click",
                selector: elms.filterClose,
                handler: this.onFilterToggle,
            },
            {
                event: "click",
                selector: elms.applyFiltersBtn,
                handler: this.onApplyFilters,
            },
            {
                event: "click",
                selector: elms.resetFiltersBtn,
                handler: this.onResetFilters,
            },
            {
                event: "click",
                selector: elms.paginationBtn,
                handler: this.onPaginationClick,
            },
            // Mission Info Popup
            {
                event: "click",
                selector: elms.missionInfoBtn,
                handler: this.onOpenMissionInfo,
            },
            {
                event: "click",
                selector: elms.missionInfoClose,
                handler: this.onCloseMissionInfo,
            },
            // Disclaimer Popup
            {
                event: "click",
                selector: elms.disclaimerClose,
                handler: this.onCloseDisclaimerPopup,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
    }

    async render() {
        const data = this._data;
        const missions = await this.fetchMissions();

        this._data.departments = CONFIG.game.departments;
        this._data.rarity_levels = CONFIG.game.rarity_levels;
        this._data.missions = {
            ...this._data.missions,
            key: missions?.key_missions,
            location: missions?.location_missions,
        };
        this._data.colleague_cards = missions?.colleague_cards || [];

        const htmlTemplate = $("#" + this.template).html();
        const html = compile(htmlTemplate, data);
        $(".app").html(html);

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("location_mission_id")) {
            sessionStorage.setItem(
                MissionPage.MISSION_OVERVIEW_TAB_STORAGE_KEY,
                "location",
            );
        }
        this.restoreMissionOverviewTab();
    }

    setGameState() {
        this.checkIfHasParams();
    }

    async fetchMissions() {
        const [response] = await bdjs.goAsync(bdapi.post("game/get-missions"));

        if (response?.data?.success) {
            return response?.data?.data;
        }
        return [];
    }

    checkIfHasParams() {
        const elms = this.elms;
        const searchParams = new URLSearchParams(window.location.search);
        const locationMissionId = searchParams.get("location_mission_id");

        if (locationMissionId) {
            const currentUrl = window.location.href;
            const validationResult = this.validateScan(currentUrl, false);

            // Remove location_mission_id from the URL to prevent leaking sensitive params
            const url = new URL(window.location.href);
            url.searchParams.delete("location_mission_id");
            if (window.location.href !== url.toString()) {
                window.history.replaceState({}, document.title, url.toString());
            }

            if (!validationResult.success) {
                setTimeout(() => {
                    alert(validationResult.data || "The QR code is invalid.");
                }, 100);
                return;
            }

            setTimeout(() => {
                $(`${elms.missionCard}[data-mission-id="${locationMissionId}"]`).trigger("click");
                this.handleScanLocationSuccess(locationMissionId);
            }, 750);
        }
    }

    setColleagueCardCooldown() {
        const elms = this.elms;
        const $colleagueCards = $(elms.colleagueCard);
        // in hours
        const coolDownDuration = this._data.cool_down_duration;

        $colleagueCards.each(function () {
            const $this = $(this);
            const isOnCoolDown = $this.hasClass("on-cooldown");

            // Clear any existing timer for this card
            const existingTimer = $this.data("cooldown-timer");
            if (existingTimer) {
                clearInterval(existingTimer);
                $this.removeData("cooldown-timer");
            }

            if (isOnCoolDown) {
                const cooldownAt = $this.data("cooldown-at");
                const cooldownStartTime = new Date(cooldownAt * 1000);
                // Calculate end time by adding cooldown duration (in hours converted to milliseconds)
                const cooldownEndTime = new Date(
                    cooldownStartTime.getTime() +
                        coolDownDuration * 60 * 60 * 1000,
                );
                const cooldownCardTimerText = $this.find(
                    ".js-cooldown-card-timer-text",
                );

                const updateTimer = function () {
                    const now = new Date();
                    const timeDiff = cooldownEndTime.getTime() - now.getTime();

                    // If cooldown is over, clear the timer and remove cooldown state
                    if (timeDiff <= 0) {
                        cooldownCardTimerText.text("00:00:00");
                        const timerInterval = $this.data("cooldown-timer");
                        if (timerInterval) {
                            clearInterval(timerInterval);
                            $this.removeData("cooldown-timer");
                        }

                        $this.removeClass("on-cooldown");
                        return;
                    }

                    const hours = Math.floor(timeDiff / (1000 * 60 * 60));
                    const minutes = Math.floor(
                        (timeDiff % (1000 * 60 * 60)) / (1000 * 60),
                    );
                    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

                    // Pad numbers with leading zeros
                    const hoursStr = String(hours).padStart(2, "0");
                    const minutesStr = String(minutes).padStart(2, "0");
                    const secondsStr = String(seconds).padStart(2, "0");

                    cooldownCardTimerText.text(
                        `${hoursStr}:${minutesStr}:${secondsStr}`,
                    );
                };

                // Set initial timer display
                updateTimer();

                // Update every second and store the interval ID
                const cooldownCardTimer = setInterval(updateTimer, 1000);
                $this.data("cooldown-timer", cooldownCardTimer);
            }
        });
    }

    onMissionToggle(e, el) {
        const elms = this.elms;
        const $missionOverview = $(elms.missionOverview);
        const openedTab = $(el).data("tab");
        let activeClass = "";

        if (openedTab === "key") {
            activeClass = "mission-key-active";
        } else {
            activeClass = "mission-location-active";
        }

        $missionOverview.removeClass(
            "mission-key-active mission-location-active",
        );
        $missionOverview.addClass(activeClass);

        if (openedTab === "key" || openedTab === "location") {
            sessionStorage.setItem(
                MissionPage.MISSION_OVERVIEW_TAB_STORAGE_KEY,
                openedTab,
            );
        }
    }

    /**
     * Key-mission detail content (avoid $(.js-mission-content) when location detail also exists in DOM).
     * @returns {JQuery}
     */
    getKeyMissionContent() {
        return $(this.elms.missionDetail).find(this.elms.missionContent);
    }

    /**
     * Content for whichever mission detail panel is currently active.
     * @returns {JQuery}
     */
    getActiveMissionContent() {
        const elms = this.elms;
        const $loc = $(elms.missionDetailLocation);
        const $key = $(elms.missionDetail);
        if ($loc.hasClass("active")) {
            return $loc.find(elms.missionContent);
        }
        if ($key.hasClass("active")) {
            return $key.find(elms.missionContent);
        }
        return $();
    }

    restoreMissionOverviewTab() {
        const elms = this.elms;
        const $overview = $(elms.missionOverview);
        if (!$overview.length) {
            return;
        }

        let tab = sessionStorage.getItem(
            MissionPage.MISSION_OVERVIEW_TAB_STORAGE_KEY,
        );
        if (tab !== "location" && tab !== "key") {
            tab = "location";
        }

        $overview.removeClass("mission-key-active mission-location-active");
        $overview.addClass(
            tab === "location"
                ? "mission-location-active"
                : "mission-key-active",
        );
    }

    onCloseMissionDetail() {
        const elms = this.elms;
        const $missionDetail = $(elms.missionDetail);
        const $missionDetailLocation = $(elms.missionDetailLocation);
        const $missionContent = this.getActiveMissionContent();
        const missionId = $missionContent.data("mission-id");
        const missionType = $missionContent.data("mission-type");
        if (!missionId) return;

        if (missionType === "location") {
            sessionStorage.setItem(
                MissionPage.MISSION_OVERVIEW_TAB_STORAGE_KEY,
                "location",
            );
        }

        $missionDetail.removeClass("active is-unavailable");
        $missionDetailLocation.removeClass("active is-unavailable");
        this.render();
    }

    onOpenMissionInfo() {
        const elms = this.elms;
        $(elms.missionInfoPopup).addClass("active");
    }

    onCloseMissionInfo() {
        const elms = this.elms;
        $(elms.missionInfoPopup).removeClass("active");
    }

    /**
     * Show the disclaimer popup (displayed before the incorrect snackbar).
     */
    showDisclaimerPopup() {
        const elms = this.elms;
        $(elms.disclaimerPopup).addClass("active");
    }

    /**
     * Close the disclaimer popup and then show the incorrect snackbar.
     */
    onCloseDisclaimerPopup() {
        const elms = this.elms;
        $(elms.disclaimerPopup).removeClass("active");

        if (this.pendingIncorrectCount > 0) {
            this.showIncorrectSnackbar(this.pendingIncorrectCount);
            this.pendingIncorrectCount = 0;
        }
    }

    onOpenKeyMission(e, el) {
        const $this = $(el);

        const missionId = $this.data("mission-id");
        if (!missionId) return;

        const status = $this.data("status");
        if (status === "unavailable") return;

        this.renderMissionDetailLayout(missionId, "key");
    }

    onOpenLocationMission(e, el) {
        const $this = $(el);

        const missionId = $this.data("mission-id");
        if (!missionId) return;

        const status = $this.data("status");
        if (status === "unavailable") return;

        this.renderMissionDetailLocationLayout(missionId);
    }

    onOpenScanLocationPopup() {
        const elms = this.elms;
        const $scanLocationPopup = $(elms.scanLocationPopup);
        $scanLocationPopup.addClass("active");
        this.startScanning();
    }

    onCloseScanLocation() {
        const elms = this.elms;
        const $scanLocationPopup = $(elms.scanLocationPopup);

        this.stopScanning();
        this.hideScannerUI();
        $scanLocationPopup.removeClass("active");
    }

    renderMissionDetailLocationLayout(missionId) {
        const elms = this.elms;
        const $missionDetailLocation = $(elms.missionDetailLocation);
        let missionData = this._data.missions.location.find(
            (mission) => mission.id === missionId,
        );
        if (!missionData) return;

        const detailMissionPageTitle = this._data.text_settings.detail_mission_page_title;
        missionData = {
            ...missionData,
            detailMissionPageTitle: detailMissionPageTitle.location_mission,
        };

        const htmlTemplate = $("#mission-detail-location-template").html();
        const html = compile(htmlTemplate, missionData);
        const isCompleted = missionData.status_value === "completed";
        const isUnavailable = missionData.status_value === "unavailable";

        $missionDetailLocation.html(html);
        $missionDetailLocation
            .addClass("active")
            .toggleClass("is-completed", isCompleted)
            .toggleClass("is-unavailable", isUnavailable);
    }

    renderMissionDetailLayout(missionId, type = "key") {
        if (!missionId) return;

        const elms = this.elms;
        const $missionDetail = $(elms.missionDetail);

        let missionData = this._data.missions[type].find(
            (mission) => mission.id === missionId,
        ); 
        if (!missionData) return;

        const detailMissionPageTitle = this._data.text_settings.detail_mission_page_title;
        missionData = {
            ...missionData,
            detailMissionPageTitle: detailMissionPageTitle.key_mission,
        };

        const htmlTemplate = $("#mission-detail-template").html();
        const html = compile(htmlTemplate, missionData);

        const isCompleted = missionData.status_value === "completed";
        const isUnavailable = missionData.status_value === "unavailable";

        $missionDetail.html(html);
        $missionDetail
            .addClass("active")
            .toggleClass("is-completed", isCompleted)
            .toggleClass("is-unavailable", isUnavailable);

        const self = this;
        const savedAnswers = this.getSavedAnswers();
        // const selectedCards = Object.keys(savedAnswers);
        const $cardSlots = $missionDetail.find(elms.missionContent).find(
            ".js-card-slot",
        );

        $cardSlots.each(function () {
            const $this = $(this);
            // const departmentId = $this.data("department-id");
            const slotId = $this.data("slot-id");
            const isAnswered = missionData.colleague_cards.find(colleague => colleague.slot_id === slotId)?.is_answered ? true : false;
            let colleagueId = null;

            if(isAnswered) {
                colleagueId = missionData.colleague_cards.find(colleague => colleague.slot_id === slotId)?.colleague_id || null;
            } else {
                colleagueId = savedAnswers[slotId] || null;
            }

            if (colleagueId) {
                setTimeout(() => {
                    self.onSetSelectedColleagueData(
                        slotId,
                        colleagueId,
                    );
                    $this.addClass("is-filled");
                }, 100);
            }
        });
    }

    async onOpenSelectColleaguePopup(e, el) {
        const elms = this.elms;
        const $this = $(el);
        const $parent = $this.parents(".js-card-slot");
        // const departmentId = $parent.data("department-id");
        const slotId = $parent.data("slot-id");
        const $selectColleaguePopup = $(elms.selectColleague);

        // Reset pagination and filters when opening popup
        this.currentPage = 1;
        this.filterDepartmentIds = [];
        this.filterRarityIds = [];
        this.searchQuery = "";
        $(elms.searchInput).val("");

        await this.loadColleagueCards();

        this.selectedSlotId = slotId;
        // this.selectedDepartmentId = departmentId;
        $selectColleaguePopup.addClass("active");

        this.setColleagueCardCooldown();
    }

    /**
     * Load colleague cards from API with current filters, search, and pagination.
     */
    async loadColleagueCards() {
        const htmlTemplate = $("#select-colleague-template").html();

        // Prepare filter arrays - remove 'all' from rarity_levels
        const rarityLevels = this.filterRarityIds.filter((id) => id !== "all");

        const params = {
            page: this.currentPage,
            per_page: this.perPage,
            department_ids: this.filterDepartmentIds,
            rarity_levels: rarityLevels,
            search: this.searchQuery,
        };

        const [response] = await bdjs.goAsync(
            bdapi.post("game/get-colleague-cards", params),
        );

        if (!response?.data?.success) {
            return;
        }

        const result = response.data.data;
        const colleagueCards = result.cards || [];
        this.pagination = result.pagination;
        this._data.colleague_cards = colleagueCards;

        const savedAnswers = this.getSavedAnswers();
        const selectedCards = Object.values(savedAnswers);
        const modifiedColleagueCards = colleagueCards.map((card) => {
            const hasSelected = selectedCards.includes(card.colleague_id);
            const isOnCoolDown = card.is_on_cool_down;

            return {
                ...card,
                hasSelected: isOnCoolDown ? false : hasSelected,
            };
        });

        const html = compile(htmlTemplate, {
            colleague_cards: modifiedColleagueCards,
        });

        $("#select-colleague-grid").html(html);

        // Update pagination if it exists
        if (this.pagination) {
            this.updateSelectColleaguePagination();
        }
    }

    /**
     * Update select colleague popup pagination HTML and state.
     */
    updateSelectColleaguePagination() {
        if (!this.pagination) {
            return;
        }

        const htmlTemplate = $("#mission-template").html();
        const tempData = {
            ...this._data,
            pagination: this.pagination,
        };
        const html = compile(htmlTemplate, tempData);
        const $newHtml = $(html);
        const elms = this.elms;
        const $currentPagination = $(elms.pagination);
        const $newPagination = $newHtml.find(elms.pagination);

        if ($newPagination.length && $currentPagination.length) {
            $currentPagination.replaceWith($newPagination);
        } else if ($newPagination.length && !$currentPagination.length) {
            // Pagination doesn't exist yet, add it after the grid
            $("#select-colleague-grid").after($newPagination);
        } else if (!$newPagination.length && $currentPagination.length) {
            // Pagination should be removed
            $currentPagination.remove();
        }

        // Update pagination button states
        this.updatePaginationState();
    }

    /**
     * Update pagination button disabled states based on current page.
     */
    updatePaginationState() {
        if (!this.pagination) {
            return;
        }

        const elms = this.elms;
        const currentPage = this.pagination.current_page || 1;
        const totalPages = this.pagination.total_pages || 1;
        const $pagination = $(elms.pagination);

        if (!$pagination.length) {
            return;
        }

        // First button
        const $firstBtn = $pagination.find(elms.paginationFirst);
        if (currentPage <= 1) {
            $firstBtn
                .addClass(elms.paginationDisabledClass)
                .prop("disabled", true)
                .attr("aria-disabled", "true");
        } else {
            $firstBtn
                .removeClass(elms.paginationDisabledClass)
                .prop("disabled", false)
                .attr("aria-disabled", "false");
        }

        // Previous button
        const $prevBtn = $pagination.find(elms.paginationPrev);
        if (currentPage <= 1) {
            $prevBtn
                .addClass(elms.paginationDisabledClass)
                .prop("disabled", true)
                .attr("aria-disabled", "true");
        } else {
            $prevBtn
                .removeClass(elms.paginationDisabledClass)
                .prop("disabled", false)
                .attr("aria-disabled", "false");
        }

        // Next button
        const $nextBtn = $pagination.find(elms.paginationNext);
        if (currentPage >= totalPages) {
            $nextBtn
                .addClass(elms.paginationDisabledClass)
                .prop("disabled", true)
                .attr("aria-disabled", "true");
        } else {
            $nextBtn
                .removeClass(elms.paginationDisabledClass)
                .prop("disabled", false)
                .attr("aria-disabled", "false");
        }

        // Last button
        const $lastBtn = $pagination.find(elms.paginationLast);
        if (currentPage >= totalPages) {
            $lastBtn
                .addClass(elms.paginationDisabledClass)
                .prop("disabled", true)
                .attr("aria-disabled", "true");
        } else {
            $lastBtn
                .removeClass(elms.paginationDisabledClass)
                .prop("disabled", false)
                .attr("aria-disabled", "false");
        }
    }

    /**
     * Handle pagination button clicks.
     */
    onPaginationClick(event) {
        const elms = this.elms;
        const $btn = $(event.currentTarget);

        // Don't handle clicks on disabled buttons
        if (
            $btn.hasClass(elms.paginationDisabledClass) ||
            $btn.prop("disabled")
        ) {
            return;
        }

        const action = $btn.data("pagination-action");
        let targetPage = this.currentPage;

        if (action === "first") {
            targetPage = 1;
        } else if (action === "prev") {
            targetPage = Math.max(1, this.currentPage - 1);
        } else if (action === "next") {
            targetPage = Math.min(
                this.pagination?.total_pages || 1,
                this.currentPage + 1,
            );
        } else if (action === "last") {
            targetPage = this.pagination?.total_pages || 1;
        } else {
            // Fallback: try to get page from data-pagination-page
            const page = parseInt($btn.data("pagination-page"), 10);
            if (page && page > 0) {
                targetPage = page;
            }
        }

        if (targetPage !== this.currentPage && targetPage > 0) {
            this.currentPage = targetPage;
            this.loadColleagueCards();
        }
    }

    onCloseSelectColleaguePopup() {
        const elms = this.elms;
        const $selectColleaguePopup = $(elms.selectColleague);
        $selectColleaguePopup.removeClass("active");

        // Reset filters and close dropdown
        this.onResetFilters();
        $(elms.filterDropdownWrapper).removeClass("is-dropdown-active");

        this.onResetSearch();

        // Reset pagination
        this.currentPage = 1;
    }

    toggleSelectColleagueConfirmBtn() {
        const elms = this.elms;
        const $selectColleagueConfirmBtn = $(elms.selectColleagueConfirmBtn);
        const $selectedCard = $(elms.colleagueCard).filter(".selected");
        const hasSelected = $selectedCard.length > 0;

        $selectColleagueConfirmBtn.prop("disabled", !hasSelected);
    }

    onSelectColleagueCard(e, el) {
        const elms = this.elms;
        const $this = $(el);
        const $colleagueCard = $(elms.colleagueCard);
        const hasSelected = $this.hasClass("has-selected");
        const isOnCoolDown = $this.hasClass("on-cooldown");

        if (hasSelected || isOnCoolDown) return;

        $(".js-colleague-card").addClass("user-has-selected");

        $colleagueCard.removeClass("selected");
        $this.addClass("selected");
        this.toggleSelectColleagueConfirmBtn();
    }

    clearSavedAnswers() {
        // const elms = this.elms;
        const missionId = this.getKeyMissionContent().data("mission-id");
        if (!missionId) return;

        const states = Storage.get("states", {});
        delete states.answers[missionId];
        Storage.set("states", states);

        return states;
    }

    getSavedAnswers() {
        // const elms = this.elms;
        const missionId = this.getKeyMissionContent().data("mission-id");
        if (!missionId) return;

        const states = Storage.get("states");
        const savedAnswers = states?.answers?.[missionId] || {};

        return savedAnswers;
    }

    setSavedAnswers(answers) {
        // const elms = this.elms;
        const missionId = this.getKeyMissionContent().data("mission-id");
        if (!missionId) return;

        const states = Storage.get("states", {});
        if (!states?.answers) states.answers = {};
        if (!states?.answers?.[missionId]) states.answers[missionId] = {};

        states.answers[missionId] = answers;

        return Storage.set("states", states);
    }

    saveAnswer(slotId, colleagueId) {
        let savedAnswers = this.getSavedAnswers();
        savedAnswers[slotId] = colleagueId;
        this.setSavedAnswers(savedAnswers);
    }

    onCardSlotClick(e, el) {
        const $this = $(el);
        const $parent = $this.parents(".js-card-slot");
        const $addBtn = $parent.find(".js-add-btn");

        $addBtn.trigger("click");
    }

    onRemoveSelectedAnswer(e, el) {
        const elms = this.elms;
        const $card = $(el).parents(".js-card-slot");
        // const departmentId = $card.data("department-id");
        const slotId = $card.data("slot-id");
        const answerColleague = $card.data("answer-colleague");
        const $answer = $(
            elms.colleagueCard + `[data-colleague-id="${answerColleague}"]`,
        );

        $answer.removeClass("has-selected selected");

        $card
            .removeAttr("data-answer-department")
            .removeAttr("data-answer-main-department")
            .removeAttr("data-answer-colleague")
            .removeClass("is-incorrect is-filled is-checked");

        $card
            .find(".mission-detail__slot-card")
            .removeClass(function (_, className) {
                return (
                    className.match(/mission-detail__slot-card--\S+/g) || []
                ).join(" ");
            })
            .removeClass("mission-detail__slot-card--filled is-filled")
            .addClass("mission-detail__slot-card--empty is-empty");

        $card.find(".js-card-info .js-name").html("");
        $card.find(".js-card-info .js-department").html("");
        $card.find(".js-card-info .js-role").html("");

        let savedAnswers = this.getSavedAnswers();
        delete savedAnswers[slotId];
        this.setSavedAnswers(savedAnswers);

        this.toggleMissionSubmitBtn();
    }

    onSetSelectedColleagueData(slotId, colleagueId) {
        const elms = this.elms;
        const colleagues = this._data.colleague_cards;
        const colleagueData = colleagues.find(
            (colleague) => colleague.colleague_id == colleagueId,
        );

        const {
            avatar,
            first_name,
            last_name,
            department_id,
            main_department_id,
            department,
            rarity_level,
        } = colleagueData;
        const { title } = department;
        const $missionContent = this.getKeyMissionContent();
        const missionId = $missionContent.data("mission-id");
        const missionData = this._data.missions["key"].find(mission => mission.id === missionId);
        const {colleague_cards} = missionData;
        const $cardSlot = $missionContent.find(
            ".js-card-slot[data-slot-id='" + slotId + "']",
        );
        const isAnswered = colleague_cards.find(colleague => colleague.slot_id === slotId)?.is_answered || false;
        const $slotImage = $cardSlot.find(elms.slotImage);
        const $slotImageParent = $slotImage.parent();
        const $selectColleaguePopup = $(elms.selectColleague);
        const $selectedColleagueCard = $(elms.colleagueCard).filter(
            "[data-colleague-id='" + colleagueId + "']",
        );

        const answerDepartment = $cardSlot.attr("data-answer-department");
        const answerMainDepartment = $cardSlot.attr("data-answer-main-department");
        const answerColleague = $cardSlot.attr("data-answer-colleague");

        const isHasAnswer =
            (typeof answerDepartment !== "undefined" 
                || typeof answerMainDepartment !== "undefined") &&
            typeof answerColleague !== "undefined";

        if (isHasAnswer) {
            const $answer = $(
                elms.colleagueCard + `[data-colleague-id="${answerColleague}"]`,
            );
            $answer.removeClass("has-selected selected");
        }

        $cardSlot.removeClass("is-incorrect");
        $cardSlot.attr("data-answer-department", department_id);
        $cardSlot.attr("data-answer-main-department", main_department_id);
        $cardSlot.attr("data-answer-colleague", colleagueId);
        $slotImage.find("img").attr("src", avatar);

        $slotImageParent.parent().removeClass(function (_, className) {
            return (
                className.match(/mission-detail__slot-card--\S+/g) || []
            ).join(" ");
        });

        $slotImageParent
            .parent()
            .addClass(`mission-detail__slot-card--${rarity_level}`);

        $slotImageParent
            .find(".js-card-info .js-name")
            .html(first_name + " " + last_name);
        $slotImageParent.find(".js-card-info .js-department").text(title);

        $slotImageParent
            .removeClass("mission-detail__slot-card--empty is-empty")
            .addClass("mission-detail__slot-card--filled is-filled");

        $cardSlot.addClass("is-filled");

        $selectedColleagueCard.addClass("has-selected");
        $selectedColleagueCard.removeClass("selected");
        this.toggleSelectColleagueConfirmBtn();
        this.saveAnswer(slotId, colleagueId);

        if(!isAnswered && !this.isOnCoolDown(colleagueId)) {
            this.onSubmitMission(slotId, colleagueId);
        }

        if(!isAnswered && this.isOnCoolDown(colleagueId)) {
            $cardSlot.addClass("is-checked is-incorrect");
        }

        if( isAnswered || (isAnswered && this.isOnCoolDown(colleagueId))) {
            $cardSlot.addClass("is-checked is-correct");
        }

        if($missionContent.find(".js-mission-status").data("status") === "completed") {
            $cardSlot.addClass("is-checked is-correct");
        }

        $selectColleaguePopup.removeClass("active");
        // this.toggleMissionSubmitBtn();
    }

    isOnCoolDown(colleagueId) {
        const colleagues = this._data.colleague_cards;
        const colleagueData = colleagues.find(
            (colleague) => colleague.colleague_id == colleagueId,
        );
        const {is_on_cool_down} = colleagueData;
        return is_on_cool_down;
    }

    onConfirmSelectColleague() {
        const elms = this.elms;
        const $selectedCard = $(elms.colleagueCard).filter(".selected");
        const colleagueId = $selectedCard.data("colleague-id");

        this.onSetSelectedColleagueData(this.selectedSlotId, colleagueId);
    }

    toggleMissionSubmitBtn() {
        const elms = this.elms;
        const $missionSubmitBtn = $(elms.missionSubmitBtn);
        const $cardSlots = this.getKeyMissionContent().find(".js-card-slot");
        const hasSelected =
            $cardSlots.filter(".is-filled").length === $cardSlots.length;

        $missionSubmitBtn.prop("disabled", !hasSelected);
    }

    // OLD submit mission function
    // async onSubmitMission() {
    //     const elms = this.elms;
    //     const $completedAnimationPopup = $(elms.completedAnimationPopup);
    //     const missionId = $(elms.missionContent).data("mission-id");
    //     const $submitBtn = $(elms.missionSubmitBtn);
    //     const answers = $(elms.missionContent)
    //         .find(".js-card-slot")
    //         .map(function () {
    //             return {
    //                 department: Number($(this).attr("data-answer-department")),
    //                 main_department: Number($(this).attr("data-answer-main-department")),
    //                 colleague_id: Number($(this).attr("data-answer-colleague")),
    //             };
    //         })
    //         .get();

    //     const [res] = await bdjs.goAsync(
    //         bdapi.post("game/submit-mission", {
    //             mission_id: missionId,
    //             answers: answers,
    //         }),
    //     );

    //     const $cardSlots = $(elms.missionContent).find(".js-card-slot");

    //     if (res.data.success === false) {
    //         const submittedAnswers = res.data.data.answers;
    //         let incorrectCount = 0;

    //         submittedAnswers.forEach((answer, index) => {
    //             const $cardSlot = $cardSlots.eq(index);
    //             if (answer.is_correct) {
    //                 $cardSlot.addClass("is-checked is-correct");
    //             } else {
    //                 $cardSlot.addClass("is-checked is-incorrect");
    //                 incorrectCount++;
    //             }
    //         });

    //         // Show disclaimer popup first, then snackbar after it's closed
    //         if (incorrectCount > 0) {
    //             this.pendingIncorrectCount = incorrectCount;
    //             this.showDisclaimerPopup();
    //         }
    //     }

    //     if (res.data.success && res.data.point) {
    //         $cardSlots.addClass("is-checked is-correct");
    //         $submitBtn.prop("disabled", false);

    //         $completedAnimationPopup
    //             .find(".js-points")
    //             .text(res.data.data.point);
    //         $completedAnimationPopup.addClass("active");

    //         const achievement = res.data.data.achievement ?? res.data.data.achievements?.[0];
    //         if (achievement) {
    //             this.showSnackBar(formatAchievementMessage(achievement));
    //         }
    //     }
    // }

    // NEW submit mission function
    async onSubmitMission(slotId, colleagueId) {
        // const elms = this.elms;
        const $keyContent = this.getKeyMissionContent();
        const missionId = $keyContent.data("mission-id");
        const $cardSlot = $keyContent.find(
            `.js-card-slot[data-slot-id='${slotId}']`,
        );
        const missionData = this._data.missions["key"].find(mission => mission.id === missionId);
        let {colleague_cards} = missionData;
        const isAnswered = colleague_cards.find(colleague => colleague.slot_id === slotId)?.is_answered || false;
        if(isAnswered) {
            return;
        }

        const [res] = await bdjs.goAsync(
            bdapi.post("game/submit-key-mission", {
                mission_id: missionId,
                slot_id: slotId,
                colleague_id: colleagueId,
            }),
        );

        const colleagues = this._data.colleague_cards;
        const colleagueData = colleagues.find(
            (colleague) => colleague.colleague_id == colleagueId,
        );

        colleagueData.is_on_cool_down = true;

        if (res.data.success === false) {
            $cardSlot.addClass("is-checked is-incorrect");
            this.showDisclaimerPopup();
        }

        if (res.data.success) {
            $cardSlot.removeClass("is-incorrect").addClass("is-checked is-correct");
            const colleague = colleague_cards.find(c => c.slot_id === slotId);
            if (colleague) colleague.is_answered = true;

            if(res.data.data.point > 0) {
                this.lastMissionResult = this.normalizeMissionResult(res.data.data);
                this.showCheckPopup();
            }
        }
    }

    /**
     * Normalize API response to { point, achievements } for the 3-popup flow.
     * @param {Object} data - res.data.data from submit-mission
     * @returns {{ point?: number; achievements?: Array<Object> }}
     */
    normalizeMissionResult(data) {
        const achievements = Array.isArray(data.achievements)
            ? data.achievements
            : data.achievement
              ? [data.achievement]
              : [];
        return {
            point: data.point,
            achievements: achievements.length ? achievements : undefined,
        };
    }

    /** sessionStorage key for key vs location mission list tab */
    static MISSION_OVERVIEW_TAB_STORAGE_KEY = "umc_mission_overview_tab";

    /** Duration (ms) for content fade when switching to next achievement. */
    static ACHIEVEMENT_SWITCH_DURATION_MS = 250;
    /** Duration (ms) for crossfade between popups. Must match popup CSS transition. */
    static POPUP_TRANSITION_MS = 300;

    showCheckPopup() {
        $(this.elms.checkAnimationPopup).addClass("active");

        setTimeout(() => {
            this.onCheckContinue();
        }, 3000);
    }

    /**
     * Populate achievement popup DOM with the current achievementIndex (no visibility change).
     */
    populateAchievementContent() {
        const elms = this.elms;
        const achievements = this.lastMissionResult?.achievements;
        const achievementItem = achievements?.[this.achievementIndex];
        if (!achievementItem) {
            return;
        }
        const firstStep = achievementItem.steps?.[0];
        $(elms.achievementTitle).text(
            (firstStep?.title ?? achievementItem.title) || "",
        );
        const achievementSubtitle =
            this._data?.text_settings?.text_achievement_unlocked ??
            "Prestatie behaald!";
        $(elms.achievementSubtitle).text(achievementSubtitle);
        if (firstStep?.icon) {
            $(elms.achievementImg).attr("src", firstStep.icon);
        }
        $(elms.achievementPoints).text(`+${firstStep.points}`);
    }

    /**
     * Populate and show the achievement popup for the current achievementIndex.
     */
    showAchievementPopup() {
        this.populateAchievementContent();
        $(this.elms.achievementAnimationPopup).addClass("active");
    }

    /**
     * Populate and show the point popup.
     */
    showPointPopup() {
        const elms = this.elms;
        const points = this.lastMissionResult?.point;
        $(elms.pointPoints).text(points != null ? String(points) : "0");
        $(elms.pointAnimationPopup).addClass("active");
    }

    /**
     * Close all three success popups, clear state, and re-render.
     */
    closeMissionSuccessPopups() {
        const elms = this.elms;
        $(elms.checkAnimationPopup).removeClass("active");
        $(elms.achievementAnimationPopup).removeClass(
            "active achievement-animation-popup--switching",
        );
        $(elms.pointAnimationPopup).removeClass("active");
        this.lastMissionResult = null;
        this.achievementIndex = 0;
        this.handleAfterCompletion();
    }

    handleAfterCompletion() {
        // const elms = this.elms;
        const $missionContent = this.getActiveMissionContent();
        const missionType = $missionContent.data("mission-type");

        if (missionType === "location") {
            sessionStorage.setItem(
                MissionPage.MISSION_OVERVIEW_TAB_STORAGE_KEY,
                "location",
            );
            this.render();
        } else {
            this.onOpenMissionInfo();
        }
    }

    onCheckContinue() {
        if (this.lastMissionResult?.achievements?.length) {
            this.achievementIndex = 0;
            this.showAchievementPopup();
            return;
        }
        if (this.lastMissionResult?.point != null) {
            this.showPointPopup();
            return;
        }
        setTimeout(() => {
            this.closeMissionSuccessPopups();
        }, MissionPage.POPUP_TRANSITION_MS);
    }

    onAchievementContinue() {
        const elms = this.elms;
        const $achievement = $(elms.achievementAnimationPopup);
        this.achievementIndex++;
        const achievements = this.lastMissionResult?.achievements ?? [];

        if (this.achievementIndex < achievements.length) {
            $achievement.addClass("achievement-animation-popup--switching");
            setTimeout(() => {
                this.populateAchievementContent();
                $achievement.removeClass("achievement-animation-popup--switching");
            }, MissionPage.ACHIEVEMENT_SWITCH_DURATION_MS);
            return;
        }
        if (this.lastMissionResult?.point != null) {
            this.showPointPopup();
            return;
        }
        setTimeout(() => {
            this.closeMissionSuccessPopups();
        }, MissionPage.POPUP_TRANSITION_MS);
    }

    onPointClose() {
        this.closeMissionSuccessPopups();
    }

    onSeeProgress() {
        this.closeMissionSuccessPopups();
        setTimeout(() => {
            GameLogic.goToPage("profile");
        }, MissionPage.POPUP_TRANSITION_MS);

        window.navigation?.setActiveNavItem("profile");
    }

    async startScanning() {
        const readerElement = document.getElementById(
            this.elms.scannerElementId,
        );

        if (!readerElement) {
            console.warn("QR Scanner element not found");
            return;
        }

        if (this.isScanning) {
            return;
        }

        this.stopScanning();

        try {
            this.video = document.createElement("video");
            this.video.setAttribute("playsinline", "");
            this.video.setAttribute("muted", "");
            this.video.setAttribute("autoplay", "");
            this.video.playsInline = true;
            this.video.muted = true;

            this.canvas = document.createElement("canvas");
            this.canvasContext = this.canvas.getContext("2d", {
                willReadFrequently: true,
            });

            const existingVideo = readerElement.querySelector("video");
            const existingCanvas = readerElement.querySelector("canvas");

            if (existingVideo) {
                existingVideo.remove();
            }
            if (existingCanvas) {
                existingCanvas.remove();
            }

            readerElement.appendChild(this.video);
            readerElement.appendChild(this.canvas);

            void readerElement.offsetHeight;

            const constraints = {
                video: {
                    facingMode: "environment",
                    width: { ideal: 1280 },
                    height: { ideal: 720 },
                },
            };

            if (
                !navigator.mediaDevices ||
                !navigator.mediaDevices.getUserMedia
            ) {
                throw new Error(
                    "Camera access is not available in this browser.",
                );
            }

            if (!window.isSecureContext && location.protocol !== "https:") {
                throw new Error(
                    "Camera access requires a secure connection (HTTPS).",
                );
            }

            this.videoStream =
                await navigator.mediaDevices.getUserMedia(constraints);

            this.video.srcObject = this.videoStream;

            try {
                await this.video.play();
            } catch (playError) {
                console.warn(
                    "Video play error (may be expected on iOS):",
                    playError,
                );
            }

            this.isScanning = true;
            this.showScannerUI();
            this.scanTick();
        } catch (err) {
            console.error("Failed to start QR scanner:", err);
            this.showCameraError(err);
            this.isScanning = false;
        }
    }

    /**
     * Continuously scan video frames for QR codes
     */
    scanTick() {
        if (
            !this.isScanning ||
            !this.video ||
            !this.canvas ||
            !this.canvasContext
        ) {
            return;
        }

        if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
            const videoIntrinsicWidth = this.video.videoWidth;
            const videoIntrinsicHeight = this.video.videoHeight;
            const videoDisplayWidth = this.video.offsetWidth;
            const videoDisplayHeight = this.video.offsetHeight;

            this.canvas.width = videoDisplayWidth;
            this.canvas.height = videoDisplayHeight;

            this.canvasContext.drawImage(
                this.video,
                0,
                0,
                videoIntrinsicWidth,
                videoIntrinsicHeight,
                0,
                0,
                videoDisplayWidth,
                videoDisplayHeight,
            );

            const imageData = this.canvasContext.getImageData(
                0,
                0,
                this.canvas.width,
                this.canvas.height,
            );

            const code = jsQR(
                imageData.data,
                imageData.width,
                imageData.height,
                {
                    inversionAttempts: "dontInvert",
                },
            );

            if (code) {
                this.handleScanSuccess(code.data);
                return;
            }
        }

        this.animationFrameId = requestAnimationFrame(() => this.scanTick());
    }

    handleScanSuccess(decodedText) {
        this.stopScanning();
        const validationResult = this.validateScan(decodedText);

        if (!validationResult?.success) {
            this.showScanFailed(validationResult?.data);
            return;
        }

        this.handleScanLocationSuccess(validationResult?.data);
    }

    async stopScanning() {
        if (!this.isScanning) {
            return;
        }

        try {
            if (this.animationFrameId) {
                cancelAnimationFrame(this.animationFrameId);
                this.animationFrameId = null;
            }

            if (this.videoStream) {
                this.videoStream.getTracks().forEach((track) => {
                    track.stop();
                });
                this.videoStream = null;
            }

            if (this.video) {
                this.video.srcObject = null;
                this.video = null;
            }

            this.canvas = null;
            this.canvasContext = null;

            this.isScanning = false;
            this.hideScannerUI();
        } catch (err) {
            console.error("Failed to stop QR scanner:", err);
        }
    }

    showScannerUI() {
        const scannerContainer = document.getElementById(
            this.elms.scannerElementId,
        );

        if (scannerContainer) {
            scannerContainer.classList.add("active");
        }
    }

    hideScannerUI() {
        const scannerContainer = document.getElementById(
            this.elms.scannerElementId,
        );

        if (scannerContainer) {
            scannerContainer.classList.remove("active");
        }
    }

    showCameraError(error) {
        let message = "Unable to access camera.";

        if (error.name === "NotAllowedError") {
            const isIOS =
                /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                (navigator.platform === "MacIntel" &&
                    navigator.maxTouchPoints > 1);

            if (isIOS) {
                message =
                    "Camera access denied. Please check Safari settings and ensure the site has camera permissions. You may need to refresh the page after granting permissions.";
            } else {
                message =
                    "Camera access denied. Please allow camera permissions in your browser settings.";
            }
        } else if (error.name === "NotFoundError") {
            message = "No camera found on this device.";
        } else if (error.name === "NotReadableError") {
            message = "Camera is already in use by another application.";
        } else if (error.name === "SecurityError") {
            message = "Camera access requires a secure connection (HTTPS).";
        }

        this.showScanFailed(message);

        document.dispatchEvent(
            new CustomEvent("qr:camera-error", {
                detail: { error },
            }),
        );
    }

    validateScan(decodedText, isFromMissionPage = true) {
        try {
            const url = new URL(decodedText, window.location.origin);
            const locationMissionId = Number(url.searchParams.get(
                "location_mission_id",
            ));
            
            // const elms = this.elms;
            const $missionContent = this.getActiveMissionContent();
            const missionId = $missionContent.data("mission-id");

            if (!locationMissionId) {
                const errorMessage =
                    "QR code does not contain required parameters (location_mission_id).";
                console.warn(errorMessage);
                return {
                    success: false,
                    data: errorMessage,
                };
            }

            if(isFromMissionPage && missionId !== locationMissionId) {
                const errorMessage = "The QR code is not match with the mission. Please check the QR code again.";
                console.warn(errorMessage);
                return {
                    success: false,
                    data: errorMessage,
                };
            }

            return {
                success: true,
                data: locationMissionId,
            };
        } catch (error) {
            console.error("Failed to validate scan:", error);
            return null;
        }
    }

    async handleScanLocationSuccess(locationMissionId) {
        const elms = this.elms;
        const $scanLocationPopup = $(elms.scanLocationPopup);
        const missionId = Number(locationMissionId);
        if (!missionId) return;

        const $locationMissionCard = $(
            elms.missionCard + `[data-mission-id="${missionId}"]`,
        );
        const locationMissionData = this._data.missions.location.find(mission => mission.id === missionId);
        const isNeedMission = locationMissionData.is_need_mission;

        if(isNeedMission) {
            const [res] = await bdjs.goAsync(
                bdapi.post("game/unlock-mission", {
                    mission_id: missionId,
                }),
            );
    
            if (res.data.success === false) {
                this.showScanFailed(res.data.data.message);
                return;
            }
    
            $scanLocationPopup.removeClass("active is-failed");
            $locationMissionCard
                .removeClass("is-unavailable")
                .addClass("is-available");
    
            const missionStatusLabel =
                this._data.text_settings.mission_status_label;
            const $statusBadge = $(
                elms.missionCard +
                    `[data-mission-id="${missionId}"] .js-mission-status`,
            );
    
            $statusBadge
                .removeClass("is-unavailable")
                .addClass("is-available")
                .text(missionStatusLabel.available);

            sessionStorage.setItem(
                MissionPage.MISSION_OVERVIEW_TAB_STORAGE_KEY,
                "location",
            );
            this.render();

            setTimeout(() => {
                $(elms.missionCard + `[data-mission-id="${missionId}"]`).addClass(
                    "is-highlighted",
                );
                this.showSnackBar(res.data.data.message);
            }, 500);
        } else {
            const [res] = await bdjs.goAsync(
                bdapi.post("game/completed-location-mission", {
                    mission_id: missionId
                }),
            );

            if (res.data.success === false) {
                this.showScanFailed(res.data.data.message);
                return;
            }

            if (res.data.data.point) {
                this.lastMissionResult = this.normalizeMissionResult(res.data.data);
                this.showCheckPopup();
            }
        }
    }

    showScanFailed(message) {
        const elms = this.elms;
        const $scanLocationPopup = $(elms.scanLocationPopup);
        const $scanLocationWarning = $(elms.scanLocationWarning);

        this.stopScanning();

        $scanLocationWarning
            .find(".js-warning-text")
            .text(message?.text || message);
        $scanLocationWarning.find(".js-warning-title").text(message?.title);
        $scanLocationPopup.addClass("is-failed");
    }

    onCloseScanLocationWarning() {
        const elms = this.elms;
        const $scanLocationWarning = $(elms.scanLocationWarning);
        const $scanLocationPopup = $(elms.scanLocationPopup);

        $scanLocationWarning.removeClass("active");
        $scanLocationPopup.removeClass("is-failed");
        this.startScanning();
    }

    showSnackBar(message) {
        const elms = this.elms;
        const $snackBar = $(elms.snackBar);

        $snackBar.find(".js-snackbar-text").text(message);
        $snackBar.addClass("active");
    }

    onCloseSnackBar() {
        // const elms = this.elms;
        const $missionContent = this.getKeyMissionContent();
        $missionContent.removeClass("is-mission-checked");
    }

    /**
     * Show the incorrect cards snackbar with the count
     * @param {number} count - Number of incorrect cards
     */
    showIncorrectSnackbar(count) {
        const elms = this.elms;
        const $missionContent = this.getKeyMissionContent();
        const $snackBar = $(elms.snackBar);

        // Update the count text
        $snackBar.find(".js-snackbar-count").text(count);

        // Show the snackbar by adding class to parent
        $missionContent.addClass("is-mission-checked");
    }

    onSearchInput(e) {
        const query = $(e.target).val().trim();
        this.searchQuery = query;

        // Clear existing timer
        if (this.searchDebounceTimer) {
            clearTimeout(this.searchDebounceTimer);
        }

        // Set new timer to debounce the search
        this.searchDebounceTimer = setTimeout(() => {
            this.currentPage = 1; // Reset to first page on new search
            this.loadColleagueCards();
        }, this.SEARCH_DEBOUNCE_DELAY);
    }

    onApplyFilters() {
        const elms = this.elms;
        const $departmentFilters = $(elms.departmentFilters);
        const $departmentFilterOptions = $departmentFilters.find("label");
        const $rarityFilters = $(elms.rarityFilters);
        const $rarityFilterOptions = $rarityFilters.find("label");
        this.filterRarityIds = $rarityFilterOptions
            .filter(function () {
                return $(this).find("input").prop("checked");
            })
            .map(function () {
                return $(this).find("input").val();
            })
            .get();
        this.filterDepartmentIds = $departmentFilterOptions
            .filter(function () {
                return $(this).find("input").prop("checked");
            })
            .map(function () {
                return parseInt($(this).find("input").val(), 10);
            })
            .get();

        this.currentPage = 1; // Reset to first page when filters change
        this.loadColleagueCards();
        this.onFilterToggle();
    }

    onResetFilters() {
        const elms = this.elms;
        const $departmentFilters = $(elms.departmentFilters);
        const $rarityFilters = $(elms.rarityFilters);
        $departmentFilters.find("input").prop("checked", false);
        $rarityFilters.find("input[value='all']").prop("checked", true);
        $rarityFilters.find("input[value!='all']").prop("checked", false);
        this.filterDepartmentIds = [];
        this.filterRarityIds = [];
        this.searchQuery = "";
        $(elms.searchInput).val("");
        this.currentPage = 1;
        this.loadColleagueCards();
        this.onFilterToggle();
    }

    onResetSearch() {
        const elms = this.elms;
        const $searchInput = $(elms.searchInput);
        $searchInput.val("");
        this.searchQuery = "";
    }

    onFilterToggle() {
        const elms = this.elms;
        $(elms.filterDropdownWrapper).toggleClass("is-dropdown-active");
    }

    beforeDestroy() {
        if (this.isScanning) {
            this.stopScanning();
        }
    }
}
